import { BucketServiceAttachmentResponseDto, FilesApiApiGetFilesRequest } from '@nimbus/bucket-service';
import { assertServiceHost, axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { ServicePayload, TempFileDto } from '@nx-frontend/shared/types';

interface TempFileFromUrlPayload extends ServicePayload {
  url: string;
}
export const createTempFileFromUrl = async ({ host, userId, url }: TempFileFromUrlPayload): Promise<TempFileDto> => {
  const response = await axiosClient.post(
    `${assertServiceHost(host)}/v1/tempfileFromExternalImageUrl`,
    {
      url,
    },
    { userId }
  );
  return response.data;
};

export const patchAttachmentClientApi = async (payload: { globalId: string; filename: string }) => {
  return await axiosClient.patch<BucketServiceAttachmentResponseDto>(`${generalEnv.nextApiPath}/attachments`, payload);
};

export const getFilesClientApi = async (params: FilesApiApiGetFilesRequest) => {
  return await axiosClient.get(`${generalEnv.nextApiPath}/attachments`, { params });
};

export const deleteFileClientApi = async (globalId: string) => {
  return await axiosClient.delete(`${generalEnv.nextApiPath}/attachments`, { params: { globalId } });
};
